<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12">
    <div
      v-if="canAdd"
      class="data-list-item add mb-2"
      @click.stop="$emit('add')"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="user"
          class="card-body-icon"
        />
      </div>
    </div>
    <div class="form-check form-switch ml-3 mb-2">
      <input
          class="form-check-input"
          type="checkbox"
          id="activeUsersCheckbox"
          v-model="activeUsers"
          @change="filterActiveUsers"
      />
      <label class="form-check-label ms-2" for="activeUsersCheckbox">
          {{ $t('contractor_reports.only_active_users') }}
      </label>
  </div>

    <Transition name="fade">
      <div v-if="tableItems.length > 0" class="col-sm-12 list-content result-table nopads">
          <vue3-datatable
              ref="resultTable"
              :rows="tableItems"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              :sortColumn="sortBy"
              :sortDirection="sortDesc ? 'desc' : 'asc'"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              :row-class="getRowClass"
              cell-class="routa-table-cell"
              @row-click="emitEdit"
          >
          </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>
import {Roles, userHelper} from '../mixins/UserMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {toRaw} from "vue";

export default {
    name: 'UserList',
    mixins: [userHelper],
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        },
        canAdd: Boolean
    },
    data() {
        return {
            sortBy: 'last_name',
            sortDesc: false,
            selectedRowId: null,
            fields: [
                {field: 'username', title: this.$t('users.user_name'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'last_name', title: this.$t('users.last_name'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'first_name', title: this.$t('users.first_name'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'email', title: this.$t('users.email'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'company', title: this.$t('users.company'), sort: true,  headerClass: 'routa-table-header' },
                {field: 'license_holder', title: this.$t('users.license_holder_title'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'superUser', title: this.$t('users.company_super_user'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'observer', title: this.$t('users.observer'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'worker', title: this.$t('users.worker'), sort: true,  headerClass: 'routa-table-header'},
            ],
            tableItems: [],
            loading: false,
            activeUsers: true
        }
    },
    watch: {
        results() {
            this.updateTableItems()
        }
    },
    methods: {
        updateTableItems() {
            let temp = []
            this.tableItems = []
            this.results.forEach(item => {
                const superUser = this.hasSuperuser(item.rights)
                const observer = this.hasObserver(item.rights)
                const worker = this.hasWorker(item.rights)
                const isActive = superUser === 'x' || observer === 'x' || worker === 'x'

                if (!this.activeUsers || isActive) {
                    temp.push({
                        'id': item.id,
                        'username': item.username,
                        'first_name': item.first_name,
                        'last_name': item.last_name,
                        'email': item.email,
                        'company': item.company?.name,
                        'license_holder': item.license_holder?.name,
                        'superUser': superUser,
                        'observer': observer,
                        'worker': worker,
                    })
                }
            })
            this.$nextTick(() => {
                this.tableItems = temp
                this.$nextTick(() => this.scrollToSelected())
            })
        },
        filterActiveUsers() {
            this.updateTableItems()
        },
        getRowClass(user) {
            if (user.id === this.selectedRowId) {
                return 'routa-table-row selected-row row-id-' + user.id
            }
            return (user.superUser !== 'x' && user.observer !== 'x' && user.worker !== 'x')?
                'routa-table-row danger-row row-id-'+user.id : 'routa-table-row row-id-\'+user.id'
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.results.length) {
                this.selectedRowId = this.results[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
        },

        scrollToSelected() {
            if (this.selectedRowId) {
                const rowElement = document.querySelector(`.row-id-${this.selectedRowId}`)
                if (rowElement) {
                    rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
                } else {
                    this.selectedRowId = null
                }
            }
        },

        emitEdit: function (result) {
            let item = this.results.find(item => result.id === item.id)
            if (item) {
                this.selectedRowId = item.id
                this.$emit('edit', item)
            }
        },

        hasObserver(rights) {
            return rights && rights.find(item => (item.role.role === Roles.OBSERVER && !item.removed_at)) !== undefined ? 'x' : ''
        },
        hasWorker(rights) {
            return rights && rights.find(item => (item.role.role === Roles.WORKER && !item.removed_at)) !== undefined ? 'x' : ''
        },
        hasSuperuser(rights) {
            return rights && rights.find(item => (item.role.role === Roles.COMPANY_SUPER_USER && !item.removed_at)) !== undefined ? 'x' : ''
        },
    }
}
</script>
